(function () {
  'use strict';

  function bindMobileParentLinks(root) {
    if (!window.matchMedia('(max-width: 1200px)').matches) return;

    var links = (root || document).querySelectorAll('[data-ginyhome-mobile-parent-link]');

    links.forEach(function (link) {
      if (link.dataset.ginyhomeMobileParentBound === 'true') return;

      var trigger = link.nextElementSibling;
      if (!trigger || !trigger.matches('[data-collapsible-trigger]')) return;

      link.dataset.ginyhomeMobileParentBound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        trigger.click();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindMobileParentLinks(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    bindMobileParentLinks(event.target);
  });
})();
